import React, { useEffect,useState } from 'react'
import ScreenSizes from '../../../configTools/screenSizes';
import ApiUrl from '../../../configTools/apiUrl';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay  } from 'swiper';



// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/autoplay';


const TopSlider = () => {
    const [slides, setSlides] = useState([]);
    const width = window.innerWidth;
    useEffect(()=>{
      fetch(ApiUrl.API_URL_Page+(width < ScreenSizes.Mobile ? "/2/1": "/1/1"))
      .then(res=>res.json())
      .then(data =>{
        setSlides(data);
      });
    },[])
  return (
    <div className='public_home_mainslider_container'>
        <Swiper
        modules={[Navigation,Autoplay]}
        slidesPerView={1}
        navigation={true}
        scrollbar={{ draggable: true }}
        autoplay={{
            delay: 5000,
            disableOnInteraction: false
        }}
        >
        {
            slides.map((item,index)=>{
                return(
                <SwiperSlide key={index}>
                    <div className='public_home_hero_container'>
                    <img src={ApiUrl.API_URL_Image_HD+item.value} alt='hero'/>
                    </div>
                </SwiperSlide>
                )
            })
        }
        </Swiper>
    </div>
  )
}

export default TopSlider
